import { STEPS_PATHS } from "./constants";
import moment from "moment";

export * from "./service";
export * from "./storage";
export * from "./constants";

export const sortListByAttribute = (list, attribute) => {
  return list.reduce((accumulator = {}, current) => {
    if (accumulator[current[attribute]]) {
      return {
        ...accumulator,
        [current[attribute]]: [...accumulator[current[attribute]], current]
      };
    }
    return {
      ...accumulator,
      [current[attribute]]: [current]
    };
  }, {});
};

export const getCurrentStepsPaths = index =>
  STEPS_PATHS.reduce((accumulator, currentValue, currentIndex) => {
    if (currentIndex < index) {
      return [...accumulator, currentValue];
    }
    if (currentIndex === index) {
      return [
        ...accumulator,
        {
          ...currentValue,
          active: true
        }
      ];
    }
    return accumulator;
  }, []);

export const formatDateToLocale = date => moment(date).format("DD/MM/YYYY");

export const formatDateToUSA = date =>
  moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");

export const getDateOptions = (inicialDate, limitDate) => {
  let dates = [];
  if (inicialDate > limitDate) {
    return dates;
  }
  var days;
  do {
    dates.push(formatDateToLocale(inicialDate));
    inicialDate.add(1, "days");

    days = limitDate.diff(inicialDate, "days");
  } while (days >= 0);
  return dates;
};

export const getSecondDateOptions = (inicialDate, limitDate) => {
  let dates = [];
  if (limitDate.diff(inicialDate, "days") <= 0) {
    dates.push(formatDateToLocale(inicialDate));
    return dates;
  }
  var days;
  do {
    dates.push(formatDateToLocale(inicialDate));
    inicialDate.add(1, "days");

    days = limitDate.diff(inicialDate, "days");
  } while (days >= 0);
  return dates;
};

export const notifyError = (self, error) => {
  self.$vs.notify({
    title: "Erro",
    text: error,
    color: "danger",
    position: "bottom-center",
    icon: "error"
  });
};

export const notifySuccess = (self, message) => {
  self.$vs.notify({
    title: "Sucesso",
    text: message,
    color: "success",
    position: "bottom-center"
  });
};

export const formatJsonIfNeeded = params => {
  const items = params;
  const keys = Object.keys(params);
  for (const key of keys) {
    let item = params[key];
    if (typeof item !== "string") continue;
    if (item.charAt(0) === "{" && item.charAt(item.length - 1) === "}") {
      try {
        item = JSON.parse(item);
      } catch (error) {
        continue;
      }
      if (typeof item === "object" && item !== null) {
        items[key] = item;
      }
    }
  }
  return items;
};

export const titleCase = text => {
  return text
    .toLowerCase()
    .split(" ")
    .map(word => {
      return word[0].toUpperCase() + word.slice(1);
    })
    .join(" ");
};
export const firstName = name => {
  const nameArray = name.split(" ");
  return `${titleCase(nameArray[0])}`;
};

// Destino pós-login (?next=): só aceita caminho interno ("/x"), nunca "//host" ou URL absoluta.
export const safeNext = next =>
  typeof next === "string" && /^\/(?![/\\])/.test(next) ? next : null;
